import React from 'react';
import { Link } from 'react-scroll';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-3xl font-bold mb-4">
              IK <span className="text-blue-400">Software</span>
            </h3>
            <p className="text-slate-400 mb-6 max-w-md">
              Building innovative software solutions that transform businesses. We turn your vision into reality with cutting-edge technology and creative thinking.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="bg-slate-800 p-2.5 rounded-lg hover:bg-blue-600 transition-colors duration-300"
                data-testid="footer-linkedin"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="bg-slate-800 p-2.5 rounded-lg hover:bg-blue-600 transition-colors duration-300"
                data-testid="footer-twitter"
              >
                <Twitter size={20} />
              </a>
              <a
                href="#"
                className="bg-slate-800 p-2.5 rounded-lg hover:bg-blue-600 transition-colors duration-300"
                data-testid="footer-github"
              >
                <Github size={20} />
              </a>
              <a
                href="#"
                className="bg-slate-800 p-2.5 rounded-lg hover:bg-blue-600 transition-colors duration-300"
                data-testid="footer-instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'Portfolio', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item.toLowerCase()}
                    smooth={true}
                    duration={500}
                    offset={-80}
                    className="text-slate-400 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                    data-testid={`footer-link-${item.toLowerCase()}`}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span className="text-sm">
                  159 Jayanagar Housing Society<br />
                  Gubbalala, Bangalore - 560061
                </span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Mail size={18} className="flex-shrink-0" />
                <a href="mailto:admin@iksoftech.com" className="text-sm hover:text-blue-400 transition-colors duration-200">
                  admin@iksoftech.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Phone size={18} className="flex-shrink-0" />
                <a href="tel:+917204081717" className="text-sm hover:text-blue-400 transition-colors duration-200">
                  +91 720 408 1717
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} IK Software Solution. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;